/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PatientMedicineNotebook,
  PatientMedicineNotebookFromJSON,
  PatientMedicineNotebookFromJSONTyped,
  PatientMedicineNotebookToJSON,
} from "./";

export const PatchMedicineNotebookResponseTypename = "PatchMedicineNotebookResponse" as const;

/**
 *
 * @export
 * @interface PatchMedicineNotebookResponse
 */
export interface PatchMedicineNotebookResponse {
  /**
   *
   * @type {PatientMedicineNotebook}
   * @memberof PatchMedicineNotebookResponse
   */
  medicineNotebook?: PatientMedicineNotebook;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatchMedicineNotebookResponse
   */
  readonly __typename?: string;
}

export function PatchMedicineNotebookResponseFromJSON(json: any): PatchMedicineNotebookResponse {
  return PatchMedicineNotebookResponseFromJSONTyped(json, false);
}

export function PatchMedicineNotebookResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchMedicineNotebookResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatchMedicineNotebookResponseTypename,

    medicineNotebook: !exists(json, "medicine_notebook")
      ? undefined
      : PatientMedicineNotebookFromJSON(json["medicine_notebook"]),
  };
}

export function PatchMedicineNotebookResponseToJSON(object?: PatchMedicineNotebookResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    medicine_notebook: PatientMedicineNotebookToJSON(value.medicineNotebook),
  };
}
